import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { StaffService } from '../../staff-service/staff.service';

@Component({
  selector: 'app-staff-shift-override-list',
  templateUrl: './staff-shift-override-list.component.html',
  styleUrls: ['./staff-shift-override-list.component.css']
})
export class StaffShiftOverrideListComponent implements OnInit, OnDestroy {
  shiftOverrideList = [];
  search: any;
  staffId;
  todayDate: any = [];
  timeZone;
  user;
  staffDetails;
  selectedStatus = 'active';

  constructor(
    private staffService: StaffService,
    private activatedRoute: ActivatedRoute,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.staffId = this.activatedRoute.snapshot.paramMap.get('id');
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).add(7, 'days').endOf('day').toISOString()
          ];

          if (this.staffId) {
            this.getStaffDetails();
          } else {
            this.getShiftOverrides();
          }
        }
      });
  }

  getStaffDetails() {
    this.staffService
      .getStaffById(this.staffId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.staffDetails = data;
          this.getShiftOverrides();
        }
      });
  }

  getShiftOverrides() {
    const payload: any = {
      startDate: moment(this.todayDate[0]).tz(this.timeZone).toISOString(),
      endDate: moment(this.todayDate[1]).tz(this.timeZone).toISOString(),
      status: this.selectedStatus,
      includeAllApprovalStatus: true
    };

    if (this.staffDetails) {
      payload.staffIds = [this.staffId];
    }

    this.staffService.getShiftOverridesByDate(payload).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.shiftOverrideList = data;
        }
      });
  }

  onDateChange(event) {
    this.todayDate = [
      moment(event[0]).toISOString(),
      moment(event[1]).endOf('day').toISOString()
    ];
    this.getShiftOverrides();
  }

  onDelete(i) {
    sweetAlert(
      "Alert",
      "Are you sure you want to remove this shift?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const item = this.shiftOverrideList[i];
        this.staffService.deleteShiftOverride(item._id).pipe(takeUntil(componentDestroyed(this)))
          .subscribe(data => {
            if (data) {
              this.shiftOverrideList.splice(i, 1);
            }
          });
      }
    });
  }

  onChangeStatus() {
    this.shiftOverrideList = [];
    this.getShiftOverrides();
  }

  onApprovalAction(item, approvalStatus: 'approved' | 'rejected') {
    sweetAlert(
      "Alert",
      `Are you sure you want to ${approvalStatus === 'approved' ? 'accept' : 'reject'} this shift override?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.staffService.updateShiftOverrideApproval(item._id, approvalStatus)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe(data => {
            if (data) {
              item.approvalStatus = approvalStatus;
            }
          }, err => {
            sweetAlert('Error', err, 'warning', 'OK');
          });
      }
    });
  }

  ngOnDestroy(): void {
  }

}
